import { requestApi } from 'api/Api';

import { showAlert } from 'components/shared/Alert/Alert';

import { formatDate } from './formatDate';

export const sendEmail = async ({
  id,
  navigate,
  onSuccess = () => {},
  onError = () => {},
  toAltEmail,
  customEmail = null
}) => {
  try {
    await requestApi({
      url: '/api/practice/billing/invoicing/email',
      params: {
        invoiceId: id,
        toAltEmail,
        customEmail
      },
      navigate,
      onSuccess,
      onError
    });
  } catch (error) {
    console.error(error);
  }
};
export const sendText = async ({
  id,
  navigate,
  onSuccess = () => {},
  onError = () => {},
  toAltPhone,
  customPhone = null
}) => {
  try {
    await requestApi({
      url: '/api/practice/billing/invoicing/text',
      params: {
        invoiceId: id,
        toAltPhone,
        customPhone
      },
      navigate,
      onSuccess,
      onError
    });
  } catch (error) {
    console.error(error);
  }
};

export const getInvoicesFromSelectedRows = (selectedRowData) => {
  const finalInvoices = selectedRowData?.reduce((acc, invoice) => {
    const { patient_id, dateofservice, last_applied } = invoice;

    if (!acc?.[patient_id]) {
      acc[patient_id] = {
        ...invoice,
        total_amount: 0,
        amount_paid: 0,
        invoice_balance: 0,
        discount: 0,
        procedures: [],
        packages: [],
        products: [],
        tax: 0,
        internal_invoice_ids: [],
        created_at: invoice?.created_at,
        dateofservice,
        write_off: 0,
        show: true,
        aeob: invoice?.aeob ?? true
      };
    }

    const patientInvoice = acc[patient_id];

    const balance = invoice?.invoice_balance ?? invoice?.balance ?? 0;

    patientInvoice.internal_invoice_ids.push(invoice.id);
    patientInvoice.id = invoice.id;
    patientInvoice.patient = invoice.patient;
    patientInvoice.total_amount += balance;
    patientInvoice.amount_paid += invoice.amount_paid;
    patientInvoice.invoice_balance += balance;
    patientInvoice.tax += invoice?.tax;
    patientInvoice.write_off += invoice?.write_off;

    // Assign discount from invoice (amount in cents); default to 0 if not provided
    if (invoice.discount !== undefined && invoice.discount !== null) {
      patientInvoice.discount = invoice.discount;
    }

    invoice?.procedures?.length > 0 &&
      patientInvoice.procedures.push(
        ...invoice.procedures.map((procedure) => ({
          ...procedure,
          dateofservice: procedure.dateofservice || invoice.dateofservice,
          last_applied,
          invoiceId: invoice.id,
          invoiceStatus: procedure.invoiceStatus || invoice.status,
          show: true
        }))
      );
    invoice?.products?.length > 0 &&
      patientInvoice.products.push(
        ...invoice.products.map((product) => ({
          ...product,
          dateofservice: product.dateofservice || invoice.dateofservice,
          invoiceId: invoice.id,
          invoiceStatus: product.invoiceStatus || invoice.status,
          show: true
        }))
      );
    invoice?.packages?.length > 0 &&
      patientInvoice.packages.push(
        ...invoice.packages.map((pkg) => ({
          ...pkg,
          dateofservice: pkg.dateofservice || invoice.dateofservice,
          invoiceId: invoice.id,
          invoiceStatus: pkg.invoiceStatus || invoice.status,
          show: true
        }))
      );
    patientInvoice.created_at = patientInvoice?.created_at || formatDate({ data: new Date() });
    patientInvoice.dateofservice =
      patientInvoice?.dateofservice || formatDate({ data: new Date() });

    return acc;
  }, {});

  return Object.values(finalInvoices);
};
export const onSendEmail = async ({
  ids = [],
  setButton = () => {},
  navigate,
  toAltEmail = false,
  isPopover = false,
  customEmail = null
}) => {
  let successEmailsCount = 0;
  if (!isPopover) {
    setButton((prev) => ({ ...prev, loading: true }));
  }
  const onSuccess = (res) => {
    if (res?.success) {
      ++successEmailsCount;
    }
    if (!isPopover) {
      setButton((prev) => ({ ...prev, label: 'Sent', loading: false }));
    }
  };
  const onError = (error) => {
    showAlert({
      title: 'Error',
      message: error,
      color: 'danger'
    });
    if (!isPopover) {
      setButton((prev) => ({ ...prev, loading: false }));
    }
  };
  const sendEmailPromises = ids.map((id) =>
    sendEmail({ id, navigate, onSuccess, onError, toAltEmail, customEmail })
  );
  await Promise.all(sendEmailPromises);
  if (successEmailsCount > 0) {
    showAlert({
      title: 'Success',
      message:
        successEmailsCount > 1
          ? `${successEmailsCount} Invoices have been sent successfully`
          : 'The invoice has been successfully sent',
      color: 'success'
    });
  }
};

export const onSendText = async ({
  ids = [],
  setButton = () => {},
  navigate,
  toAltPhone = false,
  isPopover = false,
  customPhone = null
}) => {
  let successMessagesCount = 0;
  if (!isPopover) {
    setButton((prev) => ({ ...prev, loading: true }));
  }

  const onSuccess = (res) => {
    if (res?.success) {
      ++successMessagesCount;
    }

    if (!isPopover) {
      setButton((prev) => ({ ...prev, label: 'Sent', loading: false }));
    }
  };
  const onError = (error) => {
    showAlert({
      title: 'Error',
      message: error,
      color: 'danger'
    });
    if (!isPopover) {
      setButton((prev) => ({ ...prev, loading: false }));
    }
  };

  const sendEmailPromises = ids.map((id) =>
    sendText({ id, navigate, onSuccess, onError, toAltPhone, customPhone })
  );
  await Promise.all(sendEmailPromises);

  if (successMessagesCount > 0) {
    showAlert({
      title: 'Success',
      message:
        successMessagesCount > 1
          ? `${successMessagesCount} Invoices have been sent successfully`
          : 'The invoice has been successfully sent',
      color: 'success'
    });
  }
};
